import React from 'react';

// Three health states plus "no report". A member with no health report is not healthy: the
// health job only writes while a device is in service, so an absent report means the device
// is not reporting, and a two-state pill would show a stale green for a battery that has
// been off all day.
export const HEALTH_META = {
    HEALTHY: { label: 'Healthy', className: 'ok' },
    WARNING: { label: 'Warning', className: 'warn' },
    CRITICAL: { label: 'Critical', className: 'fault' },
    none: { label: 'No report', className: 'none' },
};

export const healthMetaFor = status => HEALTH_META[status] ?? HEALTH_META.none;

/**
 * Health reporting is being tuned before it is published to retailers, so every health
 * verdict on the battery pages reads the literal "TBD" for now — the pill and the list's
 * breakdown — with the layout kept. Flip this off to publish the real values. Plain counts
 * (such as the page's "Devices reporting" tile) are not health verdicts and stay real.
 */
export const HEALTH_REPORTING_TBD = true;

const HealthPill = ({ status, detail }) => {
    if (HEALTH_REPORTING_TBD) {
        return (
            <span className="vb-health vb-health--none">
                <span className="vb-health__dot" />
                TBD
            </span>
        );
    }
    const meta = healthMetaFor(status);
    return (
        <span className={`vb-health vb-health--${meta.className}`}>
            <span className="vb-health__dot" />
            {meta.label}
            {detail ? <span className="vb-health__detail">{detail}</span> : null}
        </span>
    );
};

export default HealthPill;
